import { styled, Tabs as MuiTabs, TabsProps as MuiTabsProps } from "@mui/material";

const StyledTabs = styled(MuiTabs)(() => ({}));

interface TabsProps extends MuiTabsProps {
  children: React.ReactNode;
}

export const Tabs: React.FC<TabsProps> = ({ children, ...props }) => {
  return <StyledTabs {...props}>{children}</StyledTabs>;
};

export default Tabs;
